module.exports = __webpack_public_path__ + "img/logo-248x60.6c70ca7c.svg";